
/**
 * https://shared-fireweather.dev.apps.rfs.nsw.gov.au/geoserver/fireweather/wms?
 *      SERVICE=WMS&
 *      REQUEST=GetMap&
 *      FORMAT=image/png&
 *      TRANSPARENT=TRUE&STYLES=&
 *      VERSION=1.3.0&
 *      LAYERS=fireweather:jurisdiction&
 *      WIDTH=1400&
 *      HEIGHT=849&
 *      CRS=EPSG:3857&
 *      BBOX=14224380.617267977,-4970832.203712391,17648759.484442964,-2894191.0192612745
 */
export const getJurisdictionsObj = () => {
    return {
        geoserverId: 'jurisdiction',
        hasLegend: false,
        layerLabel: '',
        layerName: 'jurisdiction',
        layerType: '',
        legendUnits: '',
        timeStepInterval: undefined
    }
}

export const getFireWeatherAreaObj = () => {
    return {
        geoserverId: 'fire_weather_area',
        hasLegend: false,
        layerLabel: '',
        layerName: 'fire_weather_area',
        layerType: '',
        legendUnit: '',
        timeStepInterval: undefined
    }
}

export const getFireManagementAreaObj = () => {
    return {
        geoserverId: 'fire_management_area',
        hasLegend: false,
        layerLabel: '',
        layerName: 'fire_management_area',
        layerType: '',
        legendUnit: '',
        timeStepInterval: undefined
    }
}

/**
 * addWMSLayer('SurfaceWind', map.layerIds.length, true);
 * addWMSLayer('RelativeHumidity', map.layerIds.length, true);
 * addWMSLayer('AirTemp', map.layerIds.length, true);
 */
export const getSurfaceWindObj = () => {
    return {
        geoserverId: 'IDZ20010_wind',
        hasLegend: false,
        layerLabel: '',
        layerName: 'IDZ20010_wind',
        layerType: '',
        legendUnit: '',
        timeStepInterval: undefined
    }
}

export const getRelativeHumidityObj = () => {
    return {
        geoserverId: 'IDZ20010_rel_humidity',
        hasLegend: false,
        layerLabel: '',
        layerName: 'IDZ20010_rel_humidity',
        layerType: '',
        legendUnit: '',
        timeStepInterval: undefined
    }
}

export const getAirTempObj = () => {
    return {
        geoserverId: 'IDZ20010_air_temperature',
        hasLegend: false,
        layerLabel: '',
        layerName: 'IDZ20010_air_temperature',
        layerType: '',
        legendUnit: '',
        timeStepInterval: undefined
    }
}

export const getRfsAreaCommandLayerObj = () => {
    return {
        serviceUrl: '{APP_BASE_URL}/arcgis/rest/services/Public/FireWeatherRef/MapServer',
        serviceType: 'ArcGIS',
        sublayer: {
            id: 7,
        },
        hasLegend: false,
        layerLabel: '',
        layerName: 'RfsArea',
        layerType: 'MapService',
        legendUnit: '',
        timeStepInterval: undefined
    }
}